/* eslint-disable no-unused-vars */
import ApiService from "../api.service";
import appConfig from "../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const StockAdjustmentService = {
  /**
   * Get Screen data
   *
   * */
  //   async getByCode(code) {
  //     const requestScreenData = {
  //       url: "api/PurchaseOrder",
  //       top: "1",
  //       filter: `Code eq ${code}`,
  //     };

  //     return await ApiService.oDataGet(requestScreenData);
  //   },

  dataSourceConfig(params) {
    var url = "api/StockAdjustmentDetail";
    return ApiService.createDataSource(url, params);
  },

  async getActiveAccountingPeriodStartDate() {
    const requestScreenData = {
      url: "api/ActiveAccountingPeriod",
      top: "1",
      filter: `PeriodType eq 'STK'`,
      orderby: "StartDate",
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async getActiveAccountingPeriodEndDate() {
    const requestScreenData = {
      url: "api/ActiveAccountingPeriod",
      top: "1",
      filter: `PeriodType eq 'STK'`,
      orderby: "EndDate desc",
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async saveStockAdjustment(payload) {
    const url = `api/Save_StockAdjustment`;

    return await ApiService.post(url, payload);
  },

  async getCustomDataSocurce(paramUrl, params) {
    const requestScreenData = {
      url: "api/" + paramUrl,
      filter: params.filter,
    };

    if(params.expand){
      requestScreenData.expand = params.expand;
    }

    return await ApiService.oDataGet(requestScreenData);
  },

  async getProductBatch(params) {
    const requestScreenData = {
      url: "api/ProductBatch",
      filter: params.filter,
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async reverse(code){
    const url =  "api/StockAdjustment/Reverse";
    const payload = {
      Code: code,
    }
    return await ApiService.post(url, payload)
  }
};

export { StockAdjustmentService };
